import {useState} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';
import Tooltip from '@material-ui/core/Tooltip';
import {withRouter} from 'react-router-dom';
import {Icon} from 'front-onceforall-core';
import ProjectTreeRowActionsMenu from './ProjectTreeRowActionsMenu';
import DossierStateCell from '../../dossier/DossierStateCell';
import authenticationService from '../../../services/authentication/AuthenticationService';
import {interventionPropTypes} from '../../../utils/propTypes';
import {interventionRole, PROJECT_STATUS, status} from '../../../utils/constant';
import ResendButton from '../../notification/ResendButton';
import ReinviteOrganisation from './reinviteOrganisation';
import config from '../../../../config';
import ConfirmRemoveOrganisationModal from './ConfirmRemoveOrganisationModal';

export function ProjectTreeRowDossierStateAndActions(props) {
  const [isRemoveOrganisationConfirmOpen, setIsRemoveOrganisationConfirmOpen] = useState(false);
  const {intervention} = props;

  const isPendingOrRejected = [status.REJECTED, status.PENDING].includes(intervention.status);
  const isInvitedByMe = intervention.invitationEmitterOrganisation?.organisationId === props.organisation.organisationId;
  const isProjectOwner = intervention.project.ownerOrganisation.organisationId === intervention.organisation.organisationId;
  const isConsultant = authenticationService.roles().isConsultant();
  const isBackOffice = authenticationService.roles().isBackOffice();
  const isProjectActive = props.myIntervention.project.projectStatus === PROJECT_STATUS.ACTIVE;
  const isEnded = intervention.status === status.ENDED;
  const isOrganisationDeactivated = !intervention.organisation.enabled;

  if (isPendingOrRejected && isInvitedByMe && !isConsultant) {
    return (
      <span className="w-100 row">
        <div className="col-12 flex-container flex-end">
          <ResendButton
            invitation={intervention}
            onResendInvitation={() => props.onResendInvitation(intervention)}
          />
          <Tooltip title={I18n.t('invite.cancel')}>
            <button
              type="button"
              className="small secondary"
              onClick={() => props.onCancelIntervention(intervention)}
            >
              <Icon icon="trash"/>
            </button>
          </Tooltip>
        </div>
      </span>
    );
  }

  function renderRemoveOrganisation() {
    if (!isBackOffice || isProjectOwner) {
      return null;
    }

    return (
      <>
        <ConfirmRemoveOrganisationModal
          isOpen={isRemoveOrganisationConfirmOpen}
          onCancel={() => setIsRemoveOrganisationConfirmOpen(false)}
          onConfirm={() => props.onRemoveOrganisation(intervention)}
          organisationName={intervention?.organisation?.fullName}
        />
        <Tooltip title={I18n.t('organisation.delete.title')}>
          <button
            data-id="remove-organisation-button"
            type="button"
            className="small bo"
            onClick={() => setIsRemoveOrganisationConfirmOpen(true)}
          >
            <Icon icon="trash"/>
          </button>
        </Tooltip>
      </>
    );
  }

  if (!isBackOffice && !intervention.dossierStateAccessible) {
    return null;
  }

  function renderDossierState() {
    return <DossierStateCell
      data-id="dossierState"
      state={intervention.dossierState}
      tag="div"
    />;
  }

  const getRemindCommand = () => {
    if (authenticationService.roles().isExplorer() || !isProjectActive || isOrganisationDeactivated || isEnded || !intervention.organisation.depositor) {
      return null;
    }

    if (intervention.organisation.enabled) {
      const text = I18n.t('document.remind.command.title');

      return (
        <button
          data-id="remind"
          type="button"
          className="small secondary no-wrap flex-container"
          onClick={() => props.history.push(
            `/subcontractor/${intervention.organisation.organisationId}/remind?projectName=${intervention.project.name}
            &projectId=${intervention.project.projectId}&country=${intervention.project.country}&interventionId=${intervention.interventionId}`
          )}
          title={text}
        >
          <Icon icon="notification"/>
          <span className="d-none d-xl-block">{text}</span>
        </button>
      );
    }

    return null;
  };

  const showReinviteButton =
    config.featureFlags.reinviteNotDepositorInProject &&
    (intervention.role === interventionRole.SUB_CONTRACTOR || intervention.role === interventionRole.SERVICE_PROVIDER) &&
    !intervention.organisation.depositor &&
    isProjectActive &&
    !isOrganisationDeactivated &&
    !isEnded;

  return (
    <div className="row w-100">
      <div className="col-sm-8 col-xl-6">
        {intervention.dossierStateAccessible && renderDossierState()}
      </div>
      <div className="col-sm-4 col-xl-6 flex-container flex-end">
        {intervention.dossierDocumentsAccessible && getRemindCommand()}
        {showReinviteButton && <ReinviteOrganisation organisationId={intervention.organisation.organisationId}/>}
        {renderRemoveOrganisation()}
        {intervention.dossierDocumentsAccessible &&
          <ProjectTreeRowActionsMenu
            intervention={props.intervention}
            myIntervention={props.myIntervention}
            onSubmitEndOrganisation={props.onSubmitEndOrganisation}
            onRefreshProjectData={props.onRefreshProjectData}
          />
        }
      </div>
    </div>
  );
}

ProjectTreeRowDossierStateAndActions.propTypes = {
  intervention: interventionPropTypes().isRequired,
  myIntervention: interventionPropTypes().isRequired,
  organisation: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  onResendInvitation: PropTypes.func.isRequired,
  onRemoveOrganisation: PropTypes.func.isRequired,
  onSubmitEndOrganisation: PropTypes.func.isRequired,
  onCancelIntervention: PropTypes.func.isRequired,
  onRefreshProjectData: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    organisation: state.organisation
  };
}

export default withRouter(connect(mapStateToProps)(ProjectTreeRowDossierStateAndActions));
